export default __webpack_public_path__ + "static/media/insta.6ef4104d.svg";